// extracted by mini-css-extract-plugin
export default {"component":"ArticleCard_component__PRTCj","imgDiv":"ArticleCard_imgDiv__4w3MS","textDiv":"ArticleCard_textDiv__NUh3P"};